import * as React from 'react';
import s from './Customer.scss';
import get from 'lodash.get';
import { Text } from 'wix-style-react';
import { addressFormatter } from '@wix/crm-financial-formatters';
import { translate } from 'react-i18next';
import { WithCustomerLoader } from '../../loaders/loaders-builder';
var Customer = translate()(function (_a) {
    var t = _a.t, customer = _a.customer;
    var email = get(customer, 'email.address');
    var companyName = get(customer, 'company.name');
    var name = get(customer, 'name');
    var phoneNumber = get(customer, 'phone.number');
    var street = get(customer, 'address.street');
    var city = get(customer, 'address.city');
    var state = get(customer, 'address.state');
    var zip = get(customer, 'address.zip');
    var country = get(customer, 'address.country');
    var localizedLocation = addressFormatter({
        t: t,
        street: street,
        city: city,
        state: state,
        zip: zip,
        country: country,
    });
    return (React.createElement("div", { className: s.customer },
        React.createElement(Text, { className: s.customerName, size: "small", weight: "bold", dataHook: "customer-name" }, "".concat(companyName ? t('invoice-view:price-quote.view.to-customer', { name: name }) : name)),
        !!companyName && (React.createElement(Text, { size: "small", weight: "normal", dataHook: "company-name" }, companyName)),
        !!email && (React.createElement(Text, { size: "small", weight: "normal", dataHook: "customer-email" }, email)),
        !!localizedLocation && (React.createElement(Text, { size: "small", weight: "normal", dataHook: "customer-address-location" }, localizedLocation)),
        !!phoneNumber && (React.createElement(Text, { size: "small", weight: "normal", dataHook: "customer-phone-number" }, phoneNumber))));
});
export default WithCustomerLoader(translate(['invoice-view', 'locale-data'])(Customer));
//# sourceMappingURL=Customer.js.map